<template>
    <div class="omocom-insurance-accordion">
        <div class="vehicle-insurance__insurance-by">
            <span>{{ $t('pages.vehicle.insurances_by') }}</span>
            <InsuranceLogo class="insurance-logo--omocom" :vendor="vehicle.insuranceVendor" />
        </div>

        <p v-if="coverageProducts && coverageProducts.length > 0" class="omocom-insurance-accordion__subtitle">
            {{ $t('pages.vehicle.available_coverage_products', { count: coverageProducts.length }) }}
        </p>
        <Accordion class="vehicle-insurance-accordion" :items="items" :allow-multiple-open="false" slot-key="key">
            <template #header-desc-omocom_basic="{ item }">
                {{ item.priceLabel }}
            </template>
            <template #item-omocom_basic>
                <OmocomInsuranceCoverageProduct
                    mode="info"
                    :is-interior-insurance-included="isInteriorInsuranceIncluded"
                    :selected-coverage-product="basicInsuranceProduct"
                />
            </template>

            <template #header-desc-omocom_plus="{ item }">
                <VehicleAddonPrice :addon="item" />
            </template>
            <template #item-omocom_plus>
                <OmocomInsuranceCoverageProduct
                    mode="info"
                    :is-interior-insurance-included="isInteriorInsuranceIncluded"
                    :selected-coverage-product="plusInsuranceProduct"
                />
            </template>

            <template #header-desc-omocom_complete="{ item }">
                <VehicleAddonPrice :addon="item" />
            </template>
            <template #item-omocom_complete>
                <OmocomInsuranceCoverageProduct
                    mode="info"
                    :is-interior-insurance-included="isInteriorInsuranceIncluded"
                    :selected-coverage-product="completeInsuranceProduct"
                />
            </template>

            <template #before-item-young_driver>
                <div class="omocom-insurance-accordion__optional-insurances">
                    <span>{{ $t('pages.vehicle.optional_insurances') }}</span>
                </div>
            </template>
            <template #header-desc-young_driver="{ item }">
                <VehicleAddonPrice :addon="item" />
            </template>
            <template #item-young_driver>
                {{ $t('booking_addons.young_driver_description') }}
            </template>

            <template #header-desc-travel_abroad="{ item }">
                <VehicleAddonPrice :addon="item" />
            </template>
            <template #item-travel_abroad>
                {{ $t('booking_addons.travel_abroad_description') }}
            </template>
        </Accordion>
    </div>
</template>

<script>
import Accordion from '~/components/Accordion';
import OmocomInsuranceCoverageProduct from '~/components/booking/OmocomInsuranceCoverageProduct';
import { OMOCOM_BASIC, OMOCOM_COMPLETE, OMOCOM_PACKAGES, OMOCOM_PLUS } from '~/config/productTypes';
import InsuranceLogo from '~/components/InsuranceLogo';
import VehicleAddonPrice from '~/components/vehicle/VehicleAddonPrice';

export default {
    name: 'OmocomInsuranceOptions',
    components: { VehicleAddonPrice, InsuranceLogo, OmocomInsuranceCoverageProduct, Accordion },
    props: {
        vehicle: {
            type: Object,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        isInteriorInsuranceIncluded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        basicInsuranceProduct() {
            return this.items.find(item => item.key === OMOCOM_BASIC);
        },
        plusInsuranceProduct() {
            return this.items.find(item => item.key === OMOCOM_PLUS);
        },
        completeInsuranceProduct() {
            return this.items.find(item => item.key === OMOCOM_COMPLETE);
        },
        coverageProducts() {
            return this.items.filter(item => OMOCOM_PACKAGES.includes(item.key));
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.omocom-insurance-accordion {
    &__subtitle {
        @include font-size(14px);
        font-weight: 600;
    }

    ::v-deep .accordion {
        .omocom-insurance-coverage-product {
            padding: 0;
            border: none;

            &__title {
                display: none;
            }

            &__deductible {
                @include font-size(16px);
            }
        }

        .omocom-insurance-accordion__optional-insurances {
            margin: 16px 0 8px;
            padding-top: 16px;
            border-top: 1px solid $border-color;

            span {
                @include font-size(14px);
                font-weight: 600;
            }
        }
    }
}
</style>
